const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNote(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h36v36H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1342",
    d: "M973.944 113.389h-24a4 4 0 0 1-4-4v-26a4 4 0 0 1 4-4h24a4 4 0 0 1 4 4v26a4 4 0 0 1-4 4zm-24-32a2 2 0 0 0-2 2v26a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2v-26a2 2 0 0 0-2-2z",
    style: {
      fill: "current"
    },
    transform: "translate(-943.944 -78.389)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1343",
    d: "M969.944 91.389h-16a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2z",
    style: {
      fill: "current"
    },
    transform: "translate(-943.944 -78.389)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1344",
    d: "M969.944 97.389h-16a1 1 0 0 1 0-2h16a1 1 0 0 1 0 2z",
    style: {
      fill: "current"
    },
    transform: "translate(-943.944 -78.389)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 1345",
    d: "M963.944 103.389h-10a1 1 0 0 1 0-2h10a1 1 0 0 1 0 2z",
    style: {
      fill: "current"
    },
    transform: "translate(-943.944 -78.389)"
  }));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNote);
export default __webpack_public_path__ + "static/media/icon-note.e1a51afaca57d09ae9118dcf7cd5d1e6.svg";
export { ForwardRef as ReactComponent };